"use client";

import { CandidateProfilePage } from "@/modules/candidate-personalization/components/CandidateProfilePage";
import type { TalentNetworkJoinPageProps } from "../talentNetwork.types";

export function TalentNetworkJoinPage(props: TalentNetworkJoinPageProps) {
  return <CandidateProfilePage {...props} source="talent_network" />;
}
